import { takeLatest, call, put, all, select, delay } from 'redux-saga/effects';

import { Type, hide, callbackSuccess, dialogError } from './actions';

export function* callback({ payload }) {
  const { callback } = yield select(state => state.dialog);

  try {
    const data = {
      ...callback.data,
      obseng: payload.mensagem,
      newretranca: payload.mensagem,
      retranca: payload.mensagem,
      nome: payload.mensagem,
    };
    if (callback.action !== 'duplicapromo') delete data.nome;
    if (payload.mensagem === true) {
      delete data.obseng;
    }

    if (['updateretranca', 'duplica_spot'].includes(callback.action)) {
      delete data.obseng;
      delete data.newretranca;
    }
    if (
      [
        'vinculacao',
        'duracao',
        'check',
        'conferencia',
        'ingestmanual',
        'autoriza',
        'reenvio',
        'responsavelopec',
        'aprovacao',
        'reavaliar',
        'anuncio',
        'arquivamento',
        'duplicapromo',
        'locucao',
        'pre',
        'midiaatribuida',
      ].includes(callback.action)
    ) {
      delete data.obseng;
      delete data.newretranca;
      delete data.retranca;
    }

    const response = yield call(callback.method, callback.url, data);
    yield put(hide());
    yield delay(100);

    if (response)
      yield put(
        callbackSuccess({
          text: payload.successMessage,
          callback: {
            success: {
              action: callback.action || 'success',
              data: response.data || null,
            },
          },
        }),
      );
    else yield put(dialogError('Falha de comunicação com o sistema'));
  } catch (error) {
    console.log(error);
    if (
      error &&
      error.response &&
      error.reponse.data &&
      error.response.data.message
    )
      yield put(dialogError(error.response.data.message));
    else if (error.message) yield put(dialogError(error.message));
  }
}

export default all([takeLatest(Type.CALLBACK_REQUEST, callback)]);
